/**
 * Generated bundle index. Do not edit.
 */

export {MgridModule} from './public_api';

export {MgridComponent as ɵa} from './src/app/mgrid/mgrid-main/mgrid-main.component';